exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.app-banner[data-v-00aaaee3] {\n  max-width: 15rem;\n  background: white;\n  border-radius: 0.3rem;\n  padding: 0.3rem;\n}\n", ""]);
